import React from "react";
import { SelectInput } from "react-admin";

import { useEnumSelectChoices } from "../_helpers/useEnumSelectChoices";

export const SelectEnumInput = ({
	enumObj,
	enumName,
	shouldTranslate = true,
	reverse = false,
	...props
}) => {
	const choices = useEnumSelectChoices(enumObj, enumName, shouldTranslate);
	return (
		<SelectInput
			{...props}
			choices={reverse
				? Object.keys(enumObj).map((key) => ({ id: parseInt(key), name: enumObj[key] }))
				: choices}
			// parse={parse}
		/>
	);
};
